<template>
    <div id="nuevo-minuta-acuerdo">
    <v-form v-model="formularioValido" ref="registraNuevosMinutaParticipantes">
        <v-card flat>
            <v-card-title class="secondary--text mb-4">
            Registrar nuevos Participantes
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-subtitle>
            </v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col>
                  <custom-select
                  v-if="participantesLista.length>0"
                  v-model="participantesSeleccionados"
                  label="Seleccionar Participantes"
                  :items="participantesLista"
                  item-text="nombre"
                  multiple
                  return-object
                  :change="agregar()"
                  :rules="[mixReglas.requerido]">
                  </custom-select>
                  <div class="d-flex justify-space-between">
                  <h5 class="pl-5">Agregar más participantes</h5>
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                      class="base5"
                      small icon rounded v-bind="attrs" v-on="on">
                      <v-icon @click="agregarNuevo()">
                          mdi-plus
                      </v-icon>
                      </v-btn>
                    </template>
                    <span>
                        Agregar Participante
                    </span>
                    </v-tooltip>
                  </div>
                  <custom-text-field
                  cols="12"
                  class=""
                  v-model="participante.nombre"
                  label="Nombre"
                  >
                  </custom-text-field>
                  <custom-text-field
                  cols="12"
                  class=""
                  v-model="participante.puesto"
                  label="Puesto"
                  >
                  </custom-text-field>
                  <custom-select
                  v-model="participante.tipo"
                  label="Tipo"
                  :items="tipoParticipantesLista"
                  item-text="nombre"
                  item-value="tipo"
                  return-value="tipo"
                  >
                  </custom-select>
                  <v-checkbox
                  v-model="participante.recurrente"
                  :value="participante.recurrente"
                  :true-value="1"
                  :false-value=0
                  label="Recurrente"
                  color="secondary"
                  hide-details
                  class="my-0 mx-2 pl-2 text-subtitle-2">
                </v-checkbox>
                </v-col>
                <v-col>
                <v-card
                flat
                class="mx-auto base5"
                max-width="300"
                >
                <v-card-title class="bkground">
                  <span class="text-subtitle-2">Participantes</span></v-card-title>
                <v-list>
                <h5 v-show="getParticipantesPorTipo(1).length>0">Dependencia</h5>
                <v-list-item
                  v-for="(item, i) in getParticipantesPorTipo(1)"
                  :key="i"
                  :value="item"
                  color="primary"
                  class="text-caption font-weight-light"
                  variant="dependencia"
                >
                <template v-slot:prepend>
                  <v-icon :icon="item.icon"></v-icon>
                </template>
                <v-icon
                  v-if="item.recurrente==1"
                  x-small
                  color="success"
                  class="pr-1">
                    mdi-account-reactivate-outline
                </v-icon>
                <v-list-item-title v-text="item.nombre"></v-list-item-title>
                <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                  <v-icon @click="eliminar(item)">
                      mdi-delete
                  </v-icon>
                  </v-btn>
                </template>
                <span>
                    Eliminar Participante
                </span>
                </v-tooltip>
                </v-list-item>
                </v-list>

                <v-list>
                  <h5 v-show="getParticipantesPorTipo(2).length>0">Contratista</h5>
                  <v-list-item
                    v-for="(item, i) in getParticipantesPorTipo(2)"
                    :key="i"
                    :value="item"
                    color="primary"
                    variant="contratista"
                    class="text-caption font-weight-light"
                  >
                    <template v-slot:prepend>
                      <v-icon :icon="item.icon"></v-icon>
                    </template>
                    <v-icon
                      v-if="item.recurrente==1"
                      x-small
                      color="success"
                      class="pr-1">
                      mdi-account-reactivate-outline
                    </v-icon>
                    <v-list-item-title v-text="item.nombre"></v-list-item-title>
                    <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                      <v-icon @click="eliminar(item)">
                          mdi-delete
                      </v-icon>
                      </v-btn>
                    </template>
                    <span>
                        Eliminar Participante
                    </span>
                    </v-tooltip>
                  </v-list-item>
                </v-list>
                <v-list>
                  <h5 v-show="getParticipantesPorTipo(3).length>0">Supervisión Externa</h5>
                  <v-list-item
                    v-for="(item, i) in getParticipantesPorTipo(3)"
                    :key="i"
                    :value="item"
                    color="primary"
                    variant="supervisionexterna"
                    class="text-caption font-weight-light"
                  >
                    <template v-slot:prepend>
                      <v-icon :icon="item.icon"></v-icon>
                    </template>
                    <v-icon
                    v-if="item.recurrente==1"
                    x-small
                    color="success"
                    class="pr-1">
                    mdi-account-reactivate-outline
                    </v-icon>
                    <v-list-item-title v-text="item.nombre"></v-list-item-title>
                    <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                      <v-icon @click="eliminar(item)">
                          mdi-delete
                      </v-icon>
                      </v-btn>
                    </template>
                    <span>
                        Eliminar Participante
                    </span>
                    </v-tooltip>
                  </v-list-item>
                </v-list>
                <v-list>
                  <h5 v-show="getParticipantesPorTipo(4).length>0">Otros</h5>
                  <v-list-item
                    v-for="(item, i) in getParticipantesPorTipo(4)"
                    :key="i"
                    :value="item"
                    color="primary"
                    variant="otros"
                    class="text-caption font-weight-light"
                  >
                    <template v-slot:prepend>
                      <v-icon :icon="item.icon"></v-icon>
                    </template>
                    <v-icon
                    v-if="item.recurrente==1"
                    x-small
                    color="success"
                    class="pr-1">
                      mdi-account-reactivate-outline
                    </v-icon>
                    <v-list-item-title v-text="item.nombre"></v-list-item-title>
                    <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                      <v-icon @click="eliminar(item)">
                          mdi-delete
                      </v-icon>
                      </v-btn>
                    </template>
                    <span>
                        Eliminar Participante
                    </span>
                    </v-tooltip>
                  </v-list-item>
                </v-list>
                </v-card>

                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="bkground" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
        </v-card>
    </v-form>

    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import mixParticipantes from './mixParticipantes';

export default {
  name: 'NuevoMinutaParticipantes',
  mixins: [mixParticipantes],
  props: {
    idMinuta: {
      type: String,
      required: true,
    },
    participantesExistentes: {
      type: Array,
      required: true,
    },
    participantesPrimeraMinuta: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tipoParticipantesLista: [
        {
          tipo: 1,
          nombre: 'DEPENDENCIA',
        },
        {
          tipo: 2,
          nombre: 'CONTRATISTA',
        },
        {
          tipo: 3,
          nombre: 'SUPERVISION EXTERNA',
        },
        {
          tipo: 4,
          nombre: 'OTROS',
        },
      ],
      participantesSeleccionados: [],
      participantesGuardar: [],
      participante: {
        idMinuta: null,
        tipo: null,
        nombre: '',
        puesto: '',
        recurrente: 0,
      },
      participantesLista: [],
    };
  },
  components: {
    CustomButton,
    CustomTextField,
    CustomSelect,
  },
  mounted() {
    this.participantesLista = this.participantesPrimeraMinuta;
    if (this.participantesExistentes) {
      this.participantesExistentes.map((pe) => {
        const index = this.participantesLista
          .findIndex((p) => p.nombre.toUpperCase() === pe.nombre.toUpperCase());
        if (index !== -1) {
          this.participantesLista.splice(index, 1);
        }
        return true;
      });
    }
  },
  methods: {
    getParticipantesPorTipo(tipo) {
      return this.participantesGuardar
        .filter((p) => p.tipo === tipo)
        .map((p) => ({
          nombre: p.nombre,
          recurrente: p.recurrente,
        }));
    },
    getLabelsParticipantes() {
      return this.participantesLista.map((p) => ({ nombre: p.nombre }));
    },
    limpiarFormulario() {
      this.$refs.registraNuevosMinutaParticipantes.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    eliminar(item) {
      const index = this.participantesGuardar
        .findIndex((p) => p.nombre.toUpperCase() === item.nombre.toUpperCase());
      if (index !== -1) {
        this.participantesGuardar.splice(index, 1);
      }
    },
    agregar() {
      this.participantesGuardar = this.participantesSeleccionados;
    },
    agregarNuevo() {
      if (this.participante.nombre !== ''
      && this.participante.puesto !== ''
      && this.participante.tipo !== null) {
        const nuevoParticipante = {
          idMinuta: this.idMinuta,
          nombre: this.participante.nombre,
          puesto: this.participante.puesto,
          tipo: this.participante.tipo,
          recurrente: this.participante.recurrente,
        };
        this.participantesGuardar.push(nuevoParticipante);
        this.participante.nombre = '';
        this.participante.puesto = '';
        this.participante.tipo = null;
        this.participante.recurrente = 0;
      }
    },
    async guardar() {
      if (this.participantesGuardar.length > 0) {
        await this.mixAgregarParticipante();
      } else { this.cerrar(); }
    },
  },
};
</script>
